import { gql } from '@apollo/client';

export const REFRESH_TOKEN_SENTIMENT = gql`
  query RefreshTokenSentiment($ticker: String!, $forceRefresh: Boolean) {
    tokenSentiment(ticker: $ticker, forceRefresh: $forceRefresh) {
      ticker
      description
      pros
      cons
      score
      timestamp
      sources {
        url
        title
      }
    }
  }
`;
